module.exports = __webpack_public_path__ + "datahub/img/table.fe7671a5.svg";